import { combineReducers } from 'redux'
import app from './app'
import loading from './loading'
import dataCenter from './dataCenter'
import authManage from './authManage'
import userManage from './userManage'

export default combineReducers({ app, loading, dataCenter, authManage, userManage })
